import { Trans } from 'react-i18next';

import { Column, Row, Alert, Card } from 'components/Blocks';
import { PropertyWithIcon } from 'components/PropertyWithIcon';
import { UserAvatar } from 'components/UserAvatar';
import { DollarBillIcon, ReceiptLongIcon, UserIcon } from 'components/Icons';

import { PackageValue } from './PackageValue';
import { PackageOptions } from './PackageOptions';
import { PackageInvoices } from './Invoices';
import { PackageProjects } from './Projects';

import { formatCurrency } from 'utils/text';
import { calculateAmountInvoiced } from './utils';

import { usePackage } from './context';
import { useLang } from 'hooks/lang';

export function MainPackageInfo() {
  const { t } = useLang();

  const { data } = usePackage();

  return (
    <Column gap="8">
      <Card flow="column" spacing="large" className="pt-4">
        <Row justifyContent="space-between">
          <h6 className="text-xl font-medium phone:text-lg">{t('information')}</h6>

          <PackageOptions />
        </Row>

        <PropertyWithIcon icon={<UserIcon />} name={t('client')} value={data?.clientName} />

        <PackageValue />

        <PropertyWithIcon
          icon={<DollarBillIcon />}
          name={t('amount-available')}
          value={formatCurrency(data?.amountAvailable || '', data?.currency)}
        />

        <PropertyWithIcon
          icon={<ReceiptLongIcon />}
          name={t('invoices')}
          value={data ? formatCurrency(calculateAmountInvoiced(data), data?.currency) : ''}
        />

        <PropertyWithIcon
          icon={<UserAvatar size={32} user={data.createdBy} />}
          name={t('created-by')}
          value={data.createdBy.name}
        />

        {data.salesPerson && (
          <PropertyWithIcon
            icon={<UserAvatar size={32} user={data.salesPerson} />}
            name={t('sales-person')}
            value={data.salesPerson.name}
          />
        )}

        {data.convertedToBalance && (
          <Alert title={t('package-converted-to-balance')} level="info">
            <Trans i18nKey="package-converted-to-balance-description" />
          </Alert>
        )}
      </Card>

      <PackageInvoices />

      <PackageProjects />
    </Column>
  );
}
